<template>
    <div class="home">
        <div style="width: 100%; max-width: 1020px; margin: 20px auto;">
            <video autoplay loop muted poster="../assets/video/MAIN_5.gif" preload="auto"
                   src="../assets/video/rev&GOU.mp4"
                   width="100%"></video>
        </div>
        <h1 style="text-align: center;">Серия «КНИГА&#8209;ЧАТ»</h1>
        <!--    <a class="book-container"-->
        <!--       href="#"-->
        <!--       onclick="return false"-->
        <!--       target="_blank"-->
        <!--       rel="noreferrer noopener"-->
        <!--    >-->
        <!--      <div class="book">-->
        <!--        <img-->
        <!--            alt="Revizor"-->
        <!--            src="../assets/img/book1.jpg"-->
        <!--        />-->
        <!--      </div>-->
        <!--    </a>-->


        <br>
        <br>
        <h2>А. С. Грибоедов «ГОРЕ ОТ УМА»</h2>
        <div id="flipGOU" style="text-align:center; padding-top: 20px;">
            <div style="margin:8px 0px 4px;"><a href="https://www.calameo.com/books/00640418546ac142f5c4b"
                                                target="_blank"></a>
            </div>
            <iframe allowfullscreen
                    allowtransparency frameborder="0" scrolling="no"
                    src="//v.calameo.com/?bkcode=00640418546ac142f5c4b&mode=mini&clickto=view&autoflip=4&clicktarget=_self"
                    style="margin:4px 0px 8px;"></iframe>
        </div>

        <h2 style="margin-top: 40px;">Н. В. Гоголь «РЕВИЗОР»</h2>

        <div id="flipREVIZOR" style="text-align:center; padding-top: 20px;">
            <div style="margin:8px 0px 4px;"><a href="https://www.calameo.com/books/006404185504df0a220f4"
                                                target="_blank"></a>
            </div>
            <iframe allowfullscreen
                    allowtransparency frameborder="0" scrolling="no"
                    src="//v.calameo.com/?bkcode=006404185504df0a220f4&mode=mini&clickto=view&autoflip=4&clicktarget=_self"
                    style="margin:4px 0px 8px;"></iframe>
        </div>

        <div class="about">
            <h3 style="margin-bottom: 16px; text-align: left;">Дорогой читатель!</h3>


            <p>Предлагаю вам новый и уникальный <strong>проект, призванный привить ребёнку любовь к чтению через
                                                        привычные ему средства коммуникации</strong>.</p>
            <p>Дети разные. И новое поколение уже не так охотно обращается к книгам, так как чтение требует довольно
               больших затрат энергии и времени. Обычная бумажная книга привлекает школьника всё меньше, всё больше он
               предпочитает читать «лёгкие» тексты с экрана электронного устройства. <strong>Как увлечь ребёнка чтением
                                                                                             серьёзной классической
                                                                                             литературы?</strong>
               Скольжение по тексту и клиповость мышления у школьников уже стали бичом современного образования.
                <strong>Как же развиваться современному школьнику</strong> без глубокого чтения серьёзной литературы,
               когда это является основным методом не только получения информации, но и познания мира?!</p>
            <p>В ответ на этот вопрос три года назад и родилась идея этого проекта. Я заметил, что дети всё чаще наотрез
               отказываются читать литературу, но, когда у ребёнка появляется собственный смартфон, он активно
               пользуется мессенджерами, чатами и прочими программами для передачи текстовой информации. Возможно,
                <strong>современному ребёнку нужна новая форма подачи материала</strong>.</p>
            <p>Почему форматом представления текста мною выбран именно чат и почему в этот формат вложены именно пьесы?
               Ответ прост: драматургический канон и форма интернет-переписки имеют схожие основы, и это — <strong>диалогичность
                                                                                                                   формы</strong>.
               Реплики персонажей органично легли в привычную для каждого <strong>форму интернет-чата</strong>. Динамика
               появления персонажей на сцене также подобна поведению пользователей в групповых чатах.</p>
            <p>После издания первой книги серии «КНИГА-ЧАТ» — <strong>пьесы Николая Васильевича Гоголя
                                                                      «Ревизор»</strong> — в форме чата стало очевидно,
               что такая подача информации весьма эффективна. Читатели отмечают удобство восприятия, лёгкость переходов
               между репликами, особую визуальную гармонию текста.</p>
            <p>Я прекрасно понимаю роль классической литературы в развитии человека, становлении его как личности и
               именно поэтому решил продолжить серию такой замечательной пьесой, как <strong>«Горе от ума»</strong>. Это
               мой <strong>издательский трибьют Александру Сергеевичу Грибоедову</strong>.</p>
            <p>Поразмыслить над текстом пьесы предлагается и в этом печатном издании: разработаны <strong>эвристические
                                                                                                          задания по
                                                                                                          тексту</strong>
               «Горя от ума», задания на внимательность и сообразительность, которые обязательно понравятся юным
               читателям, и приложения.</p>
            <p>Серия «КНИГА-ЧАТ» состоит из известных произведений классической русской и зарубежной литературы и будет
               издаваться на нескольких языках.</p>
            <p>Желаю вам приятного чтения. Свои отзывы, предложения и мнения можете высказывать по адресу
               bookaas232@gmail.com и в социальных сетях. </p>


            <p>Желаю вам приятного чтения. Свои отзывы, предложения и мнения можете высказывать по адресу
               bookaas232@gmail.com и
               в социальных сетях и инстаграме.</p>
            <p style="text-align: left;"><strong>#книгачат #классикатоп #теперьнескучно #удобночитать
                                                 #чтениепоновому</strong></p>

            <p style="text-align: right; font-style: italic; font-size: 12px;">Создатель серии «КНИГА-ЧАТ»<br>
                <a href="https://www.facebook.com/kanstantsin.strausau"
                   target="_blank">Константин
                                   Страусов</a></p>
        </div>


        <div class="contacts"
             style="text-align: center; justify-content: center; margin-top: 20px; display: flex; flex-direction: row; ; flex-wrap: wrap; margin: 0 46px">
            <div
                    style=" width:100%; margin-bottom: 20px; justify-content: center; margin-top: 20px; display: flex; flex-direction: row; ; flex-wrap: wrap;">
                <!--        <v-btn class="blue darken-1 white&#45;&#45;text" target="_blank" large-->
                <!--               href="http://sunduchok-knig.by/shop/modern-fiction-for-teens/chat-kniga/revizor_chat-kniga/">купить в-->
                <!--          Беларуси-->
                <!--        </v-btn>-->


                <!--      <a href="https://docs.google.com/forms/d/1y1P8x3YmZWsubNdpj7GKUntbrMIeX_3_iksu810FXRw" target="_blank">заказать из-->
                <!--        других стран</a>-->
                <v-btn class="primary darken-1 white--text" href="/order2" large x-large>заказать книги
                </v-btn>


            </div>
            <v-btn color="primary" href="mailto:bookaas232@gmail.com" text>
                <v-icon class="mr-1">mdi-email-outline</v-icon>
                написать нам e-mail
            </v-btn>


<!--            <v-btn color="primary" href="https://t.me/chat_book_ru" text>-->
<!--                <v-icon class="mr-1">mdi-telegram</v-icon>-->
<!--                телеграм-канал-->
<!--            </v-btn>-->


<!--            <v-btn color="primary" href="https://www.facebook.com/chatbookru/" text>,-->
<!--                <v-icon class="mr-1">mdi-facebook</v-icon>-->
<!--                                                                                    страница в Facebook-->
<!--            </v-btn>-->


<!--            <v-btn color="primary" href="https://www.instagram.com/chat_book_ru/" text>-->
<!--                <v-icon class="mr-1">mdi-instagram</v-icon>-->
<!--                Instagram-->
<!--            </v-btn>-->


            <!--      <v-btn color="primary"-->
            <!--             href="https://www.pinterest.com/kosta232st/%D0%BA%D0%BD%D0%B8%D0%B3%D0%B0-%D1%87%D0%B0%D1%82/" text>-->
            <!--        <v-icon class="mr-1">mdi-pinterest</v-icon>-->
            <!--        наш Pinterest-->
            <!--      </v-btn>-->


            <v-btn color="primary" href="https://vk.com/public198513768" text>
                <v-icon class="mr-1">mdi-vk</v-icon>
                страница в VK
            </v-btn>


            <div
                    style="width: 100%; justify-content: center; margin-top: 20px; display: flex; flex-direction: row; ; flex-wrap: wrap; align-items: center;">

                <h3 style="color: gray;">
                    персонально:
                </h3>

                <v-btn color="primary" href="tel:%2B375296751801" text>
                    <v-icon class="mr-1">mdi-phone</v-icon>
                    позвонить
                </v-btn>


                <v-btn color="primary" href="viber://add?number=%2B375296751801" text>
                    <!--                <v-icon class="mr-1">mdi-phone-hangup</v-icon>-->
                    <v-img src="../assets/img/iconfinder_359_Viber_logo_4375169.png"
                           style="margin-right: 8px;filter: hue-rotate(-70deg)"
                           width="24px"></v-img>
                    Viber
                </v-btn>


                <v-btn color="primary" href="tg://resolve?domain=KanstantsinS" text>
                    <v-icon class="mr-1">mdi-telegram</v-icon>
                    telegram
                </v-btn>


            </div>
        </div>
        <div class="aboutIP">
            <div>
                <p>СТРАУСОВ КОНСТАНТИН ГЕОРГИЕВИЧ ИП</p>
                <p>г. Минск, ул.Гинтовта, д.26, кв.51</p>
                <p>УНП 191205722</p>
                <p>Свидетельства о регистрации № 191205722 от 11 марта 2009 г. в Республике Беларусь выдано Минским
                   Горисполкомом</p>
                <p>Расчетный счет:</p>
                <p>Код банка PJCBBY2X</p>
                <p>BY 81 PJCB 3013 0154231000000 933</p>
                <p>Г. МИНСК, "ПРИОРБАНК" ОАО</p>
                <p>ЦБУ 117, г. Минск, пр-т Независимости, 172</p>
            </div>

            <div>
                <p>Интернет-магазин зарегистрирован в Торговом реестре РБ 08.11.2021 года</p>
                <p>Способы оплаты:</p>
                <li>Наложенный платеж: Мы высылаем Вам заказ СДЭКом, Белпочтой, Европочтой. Вы оплачиваете заказ в
                    момент
                    его получения картой или наличными.
                </li>
                <li>Банковская карта (скоро появится):
                    Мы будем принимать карты всех банков мира (включая белорусские банки) следующих типов (обязательно с
                    CVC-кодом): VISA Classic, VISA Gold, VISA Platinum, MasterCard Standard, MasterCard Gold, MasterCard
                    Platinum.
                    Оплата будет производится через интернет в режиме реального времени после оформления и согласования
                    с
                    нами заказа.
                </li>
                <li>Через систему Расчет (ЕРИП) (скоро появится)</li>
            </div>
            <div>
                <p>Доставка:</p>
                <li style="margin-bottom: 12px;">Мы высылаем Вам заказ СДЭКом, Белпочтой, Европочтой наложенным платежом. </li>

                <p>e-mail: bookaas232@gmail.com</p>
                <p> Телефон: +375 29 675 18 01 (A1)</p>
            </div>
        </div>

        <v-system-bar
                window>
            <v-spacer></v-spacer>

            <small>© 2020–{{ (new Date).getFullYear()}}
                <a href="https://www.facebook.com/kanstantsin.strausau"
                   target="_blank">Kanstantsin Strausau</a></small>
            <v-spacer></v-spacer>
        </v-system-bar>

        <!--        <div style="text-align:center;"><small>© 2020 Kanstantsin Strausau</small></div>-->
    </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
    name: 'Home',
    components: {
        // HelloWorld
    },
    mounted() {
        let video = document.querySelector('video');
        setInterval(() => {
            video.play();
            video.click();
        }, 2000);
        video.addEventListener("canplaythrough", function () {
            console.log('rrrrrrrrrr');
            video.play();
        }, false);
    }
}
</script>

<style lang="scss" scoped>
.book-container {
    display: flex;
    align-items: center;
    justify-content: center;
    perspective: 800px;
    margin-top: 70px;
    margin-bottom: 20px;
}

@keyframes initAnimation {
    0% {
        transform: rotateY(0deg);
    }
    100% {
        transform: rotateY(-29deg);
    }
}

.book {
    width: 300px;
    height: 450px;
    position: relative;
    transform-style: preserve-3d;
    transform: rotateY(-29deg);
    transition: 2s ease;
    animation: 1s ease 0s 1 initAnimation;
}

.book:hover {
    transform: rotateY(0deg);
}

.book > :first-child {
    position: absolute;
    top: 0;
    left: 0;
    background-color: red;
    width: 300px;
    height: 450px;
    transform: translateZ(20px);
    background-color: #01060f;
    border-radius: 0 2px 2px 0;
    box-shadow: 5px 5px 20px #666;
}

.book::before {
    position: absolute;
    content: ' ';
    background-color: blue;
    left: 0;
    top: 0px;
    width: 38px;
    height: 450px;
    transform: translateX(280px) rotateY(90deg);
    background: linear-gradient(90deg,
            #fff 0%,
            #f9f9f9 5%,
            #fff 10%,
            #f9f9f9 15%,
            #fff 20%,
            #f9f9f9 25%,
            #fff 30%,
            #f9f9f9 35%,
            #fff 40%,
            #f9f9f9 45%,
            #fff 50%,
            #f9f9f9 55%,
            #fff 60%,
            #f9f9f9 65%,
            #fff 70%,
            #f9f9f9 75%,
            #fff 80%,
            #f9f9f9 85%,
            #fff 90%,
            #f9f9f9 95%,
            #fff 100%
    );
}

.book::after {
    position: absolute;
    top: 0;
    left: 0;
    content: ' ';
    width: 300px;
    height: 450px;
    transform: translateZ(-20px);
    background-color: rgba(240, 211, 215, 0);
    border-radius: 0 2px 2px 0;
    box-shadow: -10px 0 50px 10px #666;
}

iframe {
    width: 480px;
    height: 300px;

    @media (min-width: 800px) {
        width: 600px;
        height: 400px;
    }
    @media (min-width: 1100px) {
        width: 1100px;
        height: 720px;
    }
}

.about {
    padding-left: 16px;
    padding-right: 16px;


    @media (min-width: 800px) {
        column-count: 2;
        column-gap: 40px;
        padding-left: 76px;
        padding-right: 76px;
    }
    @media (min-width: 1100px) {
        column-count: 3;
        column-gap: 40px;
    }

    margin-top: 40px;
    margin-bottom: 60px;
    text-align: justify;
    /*max-width: 600px;*/
    /*margin-left: auto;*/
    /*margin-right: auto;*/
}

@media (max-width: 400px) {
    body {
        transform: scale(0.65);
        margin-top: -35px;
    }

    iframe {
        width: 220px;
    }

}

h1 {
    margin-top: 30px;
}


.contacts .v-icon {
    margin-right: 10px !important;
}

.contacts .v-btn {
    margin: 6px;
}

.aboutIP {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 50px;
    padding: 30px;
    border-top: 1px solid #ddd;
    margin-top: 30px;

    @media (max-width: 720px) {
        grid-template-columns: 1fr;
    }

    p, li {
        font-size: 10px;
        margin-bottom: 0;
        text-align: left;
    }


}
</style>
